import { Component } from '@angular/core';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';

@Component({
  selector: 'app-iptal-iade-politikasi',
  standalone: true,
  imports: [NewsletterComponent],
  templateUrl: './iptal-iade-politikasi.component.html',
  styleUrl: './iptal-iade-politikasi.component.css'
})
export class IptalIadePolitikasiComponent {

}
